import { render, staticRenderFns } from "./PoStoryListForGroup.vue?vue&type=template&id=97984f14"
import script from "./PoStoryListForGroup.vue?vue&type=script&lang=js"
export * from "./PoStoryListForGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports